import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Lock = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.31 9.49625H18.04C19.12 9.49625 20 10.3458 20 11.3753V20.1209C20 21.1604 19.12 22 18.04 22H5.96C4.88 22 4 21.1504 4 20.1209V11.3753C4 10.3358 4.88 9.49625 5.96 9.49625H6.69V6.9975C6.69 4.23888 9.07 2 12 2C14.93 2 17.31 4.23888 17.31 6.9975V9.49625ZM12 3.24938C9.75 3.24938 7.92 4.92854 7.92 6.9975V9.49625H16.08V6.9975C16.08 4.92854 14.25 3.24938 12 3.24938ZM18.04 20.7306C18.44 20.7306 18.77 20.4508 18.77 20.1109V11.3753C18.77 11.0355 18.44 10.7556 18.04 10.7556H5.96C5.56 10.7556 5.23 11.0355 5.23 11.3753V20.1109C5.23 20.4508 5.56 20.7306 5.96 20.7306H18.04ZM11.38 14.4938C11.38 14.1539 11.66 13.8741 12 13.8741C12.34 13.8741 12.62 14.1539 12.62 14.4938V16.9925C12.62 17.3323 12.34 17.6122 12 17.6122C11.66 17.6122 11.38 17.3323 11.38 16.9925V14.4938Z"
    />
  </svg>
)

export default withDefaultStyles(Lock)
